export default __webpack_public_path__ + "static/media/Newake-Font-Regular.4ce764bc.ttf";